<template>
  <div class="acoj-render" v-loading.fullscreen.lock="uploadLoading">
    <div class="header-wrap" v-if="problemInfo">{{ problemInfo.problem.problem_no }}.&nbsp;{{ problemInfo.problem.title }}</div>
    <div class="main-con">
      <div class="side-wrap">
        <el-tabs v-model="activeName">
          <el-tab-pane name="1">
            <span slot="label"><i class="iconfont icon-subject"></i>&nbsp;题目详情</span>
            <div class="subject-con" ref="subjectTabs" v-if="problemInfo">
              <div class="subject-title latex-format" v-html="problemInfo.problem.content"></div>
              <div style="margin-bottom: 10px;" v-if="problemInfo.problem.problem_attach && problemInfo.problem.problem_attach.length > 0" class="subject-item">
                <p><b>附件：</b></p>
                <div class="subject-item-attach">
                  <div v-for="(v,k) in problemInfo.problem.problem_attach">
                    <span>{{v.attach_name}}</span>
                    <el-button style="float: right;font-size: 0.8rem;color: #30FF57;" type="text" @click="downloadAIHomework(v.download_path, problemInfo.problem.problem_no +problemInfo.problem.title + '-' +v.attach_name)">立即下载</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="editor-wrap">
        <div class="editor-wrap-box" style="font-size: 1.2rem;" v-if="!userHomeworkResult">暂未提交作业</div>
        <div style="flex-direction: column" class="editor-wrap-box" v-else-if="!userHomeworkResult.result.show_url">
          <div class="request-loading-error"></div>
          <div style="margin-top: 2rem">文件数据过大，无法在线预览...</div>
        </div>
        <div class="editor-wrap-box" v-else>
          <div class="show-user-result" v-if="['doc','docx'].indexOf(userHomeworkResult.result.show_type) !== -1">
            <iframe style="width: 98%;height: 99%;border: none" :srcdoc="userHomeworkResult.result.show_url"></iframe>
          </div>
          <div style="text-align: center" class="show-user-result" v-if="['png','jpg','jpeg','gif'].indexOf(userHomeworkResult.result.show_type) !== -1">
            <img alt="" :src="userHomeworkResult.result.show_url" />
          </div>
          <div style="text-align: center" class="show-user-result" v-if="['mp4'].indexOf(userHomeworkResult.result.show_type) !== -1">
            <video autoplay controls loop controlsList="nodownload" disablePictureInPicture :src="userHomeworkResult.result.show_url" />
          </div>
          <div class="show-user-result" v-if="['txt'].indexOf(userHomeworkResult.result.show_type) !== -1">
            <iframe style="width: 98%;height: 99%;border: none" :srcdoc="userHomeworkResult.result.show_url"></iframe>
          </div>
        </div>
        <div class="btn-area">
          <div v-if="!userHomeworkResult" class="btn-item btn-inactive">下载</div>
          <div v-else @click="downloadAIHomework(userHomeworkResult.result.download_url, problemInfo.problem.problem_no + problemInfo.problem.title+'-'+$store.getters.userInfo.nickname+'-'+getTodayDate()+'.'+userHomeworkResult.result.show_type)" class="btn-item btn-active">下载</div>
          <el-upload
              :action="uploadAction"
              v-if="problemInfo"
              :headers="{authorization: this.$store.getters.token}"
              :before-upload="handleBefore"
              :on-success="handleSuccess"
              :file-list="fileList"
              :show-file-list="false"
              :limit="1"
              :loading="uploadLoading"
              :data="{
                formalClassHomeworkId: problemInfo.homeworkItemInfo.formal_class_homework_id,
                formalClassHomeworkItemId: problemInfo.homeworkItemInfo.id,
                problemId:problemInfo.homeworkItemInfo.problem_id,
              }"
              style="color: white;font-size: 1.3rem;"
              class="btn-item btn-active">上传文件</el-upload>
        </div>
      </div>
    </div>
  </div>
</template>
<!--<template>-->
<!--	<div class="acoj-render">-->
<!--		<div class="main-con">-->
<!--			<div class="side-wrap">-->
<!--        <div class="header-wrap" v-if="problemInfo">{{ problemInfo.problem.problem_no }}.&nbsp;{{ problemInfo.problem.title }}</div>-->
<!--        <div style="height: calc(100vh - 7rem);overflow-y: scroll;" class="subject-con" ref="subjectTabs" v-if="problemInfo">-->
<!--          <div class="subject-title latex-format" v-html="problemInfo.problem.content"></div>-->
<!--          <div v-if="problemInfo.problem.problem_attach.length > 0" class="subject-item">-->
<!--            <p><b>附件：</b></p>-->
<!--            <div class="subject-item-attach">-->
<!--              <div v-for="(v,k) in problemInfo.problem.problem_attach">-->
<!--                <span>{{v.attach_name}}</span>-->
<!--                <el-button style="float: right;font-size: 0.8rem;color: #30FF57;" type="text">立即下载</el-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--			</div>-->
<!--			<div class="editor-wrap">-->

<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
<!--</template>-->

<script>
	export default {
		name: "aiCourseRender",
		props: {
			problemInfo: {
				type: Object,
				default: null
			},
			userHomeworkResult: {
				type: Object,
				default: null
			},
      allowCopy: {
        type: Boolean,
        default: true
      }
		},
		components: {},
		data() {
			return {
				activeName: "1",
        uploadAction: process.env.VUE_APP_BASE_URL + '/formalstudent/ai_homework_upload_file',
        uploadLoading: false,
        fileList: [],
        contentHtml: ''
			}
		},
		created() {
		  console.log(this.userHomeworkResult,'userHomeworkResult')
    },
		mounted() {
		},
		watch: {
			userHomeworkResult(newData) {
			},
			problemInfo(val) {
        this.activeName = "1"
				// if (this.activeName != "1") this.activeName = "2";
        this.$nextTick(()=>{
					this.$refs.subjectTabs.scrollTo({
						top: 0,
					});
        })
			}
		},
		methods: {
			submitCode() { // 提交代码
			},
			openDialog(index) {
				this.dialog.title = `输出对比 - 测试点${index}`
				const testingPoint = this.testing_point[index]
				this.dialog.ac = testingPoint.ac
				this.dialog.diff = testingPoint.diff
				this.dialog.visible = true
			},
			randomString(e) {
				e = e || 32
				const t = '12345678'
				const a = t.length
				let n = ''
				for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
				return n
			},
      handleSuccess(response, file, fileList) {
        this.uploadLoading = false
        this.fileList = []
        if(response.status === 1){
          const data = {
            codeContent: '暂无代码',
            language: 0,
            result: response.data.rid
          }
          this.$emit('commitResult', data);
        }else{
          this.$message({
            type: 'error',
            message: response.message
          })
        }

      },
      handleBefore(f) {
        this.uploadLoading = true
      },
      handleClick(tab, event) {
        if (tab.name === 'first') {
          this.problemAnswer = this.cppCode
        } else {
          this.problemAnswer = this.pyCode ? this.pyCode : '暂无答案'
        }
        console.log(tab.name)
      },
      downloadAIHomework(url, fileName = null) {

        if(this.$isElectron() && fileName){
          const {ipcRenderer} = require("electron");
          ipcRenderer.send('download', {
            downloadPath: url, // 下载链接（以下载vue文件为例）
            fileName: fileName // 下载文件名，需要包含后缀名
          })
        }else{
          const link = document.createElement('a')
          const evt = document.createEvent('HTMLEvents')
          evt.initEvent('click', false, false)
          link.href = url
          link.download = '123.png'
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        }
      },
      getTodayDate() {
        var today = new Date();
        var year = today.getFullYear();
        var month = (today.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1，并确保两位数
        var day = today.getDate().toString().padStart(2, '0'); // 确保两位数的日期
        return year + month + day;
      }
		}
	}
</script>

<style lang="scss" scoped>
	.acoj-render {
		color: #FFF;
		height: 100%;

		.header-wrap {
			font-size: 22px;
			font-weight: 500;
			margin-bottom: 10px;
		}

		.main-con {
			display: flex;
			padding: 0 0 0 10px;
			font-size: 1rem;
			height: calc(100% - 39px);

			p {
				margin: 0 0 10px 0;
			}

			pre {
        margin: 0 0 10px 0;
        background: #1D4E64;
        color: #BCF3FF;
        border-radius: 6px;
        padding: 20px 20px;
        white-space: inherit;
        word-wrap: break-word;
        line-height: 2;
        font-family: Courier,Source Han Sans SC !important;
			}

			.side-wrap {
				width: 50%;
				margin-right: 20px;

				.subject-con {
					padding-right: 10px;

          .subject-title {
            padding: 0 0 20px 0;
            line-height: 2!important;
            font-size: 1rem;
            font-family: Courier,Source Han Sans SC !important;
            color: white!important;
            ::v-deep p {
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              color: white!important;
              span {
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
                color: white!important;
              }
            }
          }

          .subject-item {
            margin-left: 10px;
            line-height: 2!important;
            font-size: 1rem!important;
            font-family: Courier,Source Han Sans SC !important;
            .subject-item-attach{
              padding: 10px;
              background-color: #142029;
              border-radius: 2px;
              color: #BCF3FF;
              border: 1px solid #0FBFB0;
            }
            ::v-deep b{
              color: #ffffff!important;
            }
            ::v-deep p {
              color: #BCF3FF!important;
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              span {
                color: #BCF3FF!important;
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
              }
            }
          }
				}

        .subject-item-sample{
          line-height: normal!important;
          ::v-deep pre {
            line-height: normal!important;
          }
          ::v-deep p {
            line-height: normal!important;
            span {
              line-height: normal!important;
            }
          }
        }

				.no-data-wrap {
					text-align: center;
					font-size: 18px;
					margin-top: 30px;
				}

				.evaluation-con {
					padding-right: 10px;

					.evaluation-item {
						margin-bottom: 20px;
						padding-left: 20px;
            .evaluation-item-table{
              border-radius: 5px;
              background:transparent;
              ::v-deep tr{
                background:transparent;
              }
              ::v-deep th.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep td.el-table__cell{
                background: rgba(201,238,255,0.15);
              }
              ::v-deep .el-table__body tr:hover>td.el-table__cell {
                background-color: rgba(0, 0, 0, 0) !important;
              }
              ::v-deep .current-row>td.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep .el-table__expanded-cell{
                background: transparent!important;
              }
              ::v-deep pre{
                background: transparent;
                padding: 0;
              }
              ::v-deep .el-table__empty-block{
                background: rgba(201,238,255,0.15);
              }
            }
						.result {
							display: flex;
						}

						.title {
							margin-left: -10px;
						}

						.lang {
							margin-top: 8px;
						}

						.status {
							display: flex;
							justify-content: start;
							margin-top: 8px;

							div {
								margin-right: 20px;
							}
						}

						.el-table {
							.el-button {
								border: none;
								color: #FFF;
							}
						}

						::v-deep .el-table__body tr.current-row>td.el-table__cell,
						::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
							background-color: rgba(105, 187, 196, 0.3);
						}
					}
				}

				::v-deep .el-tabs {
					height: 100%;

          .el-tabs__item.is-active{
            font-size: 1rem;
            i{
              font-size: 1rem;
            }
          }
          .el-tabs__item{
            font-size: 0.7rem;
            i{
              font-size: 0.7rem;
            }
          }
          .el-tabs__content {
            height: 100%;
            overflow: auto;

						.el-tab-pane {
							height: 100%;

							.subject-con{
								height: 100%;
								overflow: auto;
							}
						}
          }
				}
			}

			.editor-wrap {
				width: 50%;
        height: calc(100vh - 8rem);
        background: rgba(23, 33, 38, 0.8);
        border: 2px solid #7CFFF4;
        border-radius: 20px;
        .editor-wrap-box{
          height: 84%;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          .show-user-result{
            width: 100%;
            height: 93%;
            overflow-y: scroll;
            margin: 20px;
            ::v-deep img{
              max-width: 98%;
              max-height: 99%;
            }
            ::v-deep video{
              max-width: 98%;
              max-height: 99%;
            }
            ::v-deep p{
              font-size: 1rem;
            }
            ::v-deep span{
              font-size: 1rem;
            }
          }
          .show-user-result::-webkit-scrollbar {
            width: 0;
          }
          .request-loading-error{
            width: 12.2rem;
            aspect-ratio: 303/485;
            background-size: 100%;
            background-repeat: no-repeat;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url(~@/assets/img/doHomework/loading-error.png);
          }
        }

        .btn-area{
          display: flex;
          justify-content: space-around;
          position: relative;
          .btn-item {
            width: 31%;
            aspect-ratio: 280/76;
            background-size: 100%;
            background-repeat: no-repeat;
            color: #FFF;
            font-size: 1.3rem;
            text-align: center;
            cursor: pointer;
            display: flex;
            align-items: center;
            letter-spacing: 4px;
            justify-content: center;
            ::v-deep .el-upload{
              color: white;
              font-size: 1.3rem;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            ::v-deep .el-upload:focus{
              color: white;
              font-size: 1.3rem;
            }
          }
          .btn-active {
            background-image: url(~@/assets/img/doHomework/zc.png);
          }

          .btn-inactive {
            background-image: url(~@/assets/img/doHomework/zhihui.png);
            cursor: no-drop;
          }
        }

			}

			.gray {
				color: #909399;
			}

			.orange {
				color: #E6A23C;
			}

			.green {
				color: #67C23A;
			}

			.red {
				color: #F56C6C;
			}

			.navy {
				color: #409EFF;
			}
		}
	}
</style>
